
export default {
    name: 'TransitionFade',
    props: {
        duration: {
            type: Number,
            default: 300,
        },
        mode: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        hooks() {
            return {
                beforeEnter: this.setDuration,
                afterEnter: this.cleanUpDuration,
                beforeLeave: this.setDuration,
                afterLeave: this.cleanUpDuration,
                ...this.$listeners,
            }
        },
    },
    methods: {
        setDuration(el) {
            el.style.animationDuration = `${this.duration}ms`
        },
        cleanUpDuration(el) {
            el.style.animationDuration = ''
        },
    },
}
